import { useState, useEffect } from "react";
import { projectAuth, projectFirestore } from "../config/config";
import { useAuthContext } from "./useAuthContext";
import { useNavigate } from "react-router";

export const useLogout = () => {
  const [error, setError] = useState(null);
  const [isPending, setIsPending] = useState(false);
  const { dispatch, user } = useAuthContext();
  const [isCancelled, setIsCancelled] = useState(false);
  const navigate = useNavigate();

  const logout = async () => {
    setError(null);
    setIsPending(true);

    try {
      const { uid } = user;
      await projectFirestore.collection("users").doc(uid).update({ online: false });

      await projectAuth.signOut();

      dispatch({ type: "LOGOUT" });

      if (!isCancelled) {
        setIsPending(false);
        setError(null);
        navigate("/login");
      }
    } catch (err) {
      if (!isCancelled) {
        console.warn(err.message);
        setError(err.message);
        setIsPending(false);
      }
    }
  };

  useEffect(() => {
    return () => {
      setIsPending(false);
      setError(null);
      setIsCancelled(true);
    }; // cleanup function to be called when component is unmounted.
  }, []);

  return { logout, error, isPending };
};
